import Marquee from "react-fast-marquee";

const WORDS = [
  "Manas — Mental Health",
  "Shakti — Women's Well-being",
  "Samskara — Conscious Parenting",
  "Tattva Bodh — Samatva Weekly",
  "Vaarta Stories",
  "Podcast",
  "Ahaar — Food Beyond Nourishment",
  "Spirituality & Indian Wisdom",
];

export const EditorialMarquee = () => (
  <div
    data-testid="editorial-marquee"
    className="marquee-mask bg-samatva-lavender/60 border-y border-samatva-line py-6 overflow-hidden"
  >
    <Marquee speed={30} gradient={false}>
      {WORDS.map((w, i) => (
        <span key={w} className="flex items-center">
          <span className="font-serif text-2xl md:text-3xl font-light text-samatva-ink/80 mx-10 whitespace-nowrap">
            {w}
          </span>
          <span className="text-samatva-plum text-lg">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
